import Geometry from '@arcgis/core/geometry/Geometry';
import Graphic from '@arcgis/core/Graphic';
import SimpleFillSymbol from '@arcgis/core/symbols/SimpleFillSymbol';
import SimpleLineSymbol from '@arcgis/core/symbols/SimpleLineSymbol';
import SimpleMarkerSymbol from '@arcgis/core/symbols/SimpleMarkerSymbol';
import TextSymbol from '@arcgis/core/symbols/TextSymbol';
import { TextSketchInputProperties } from './TextSketchInputProperties';

export type SketchInputType =
  | 'sketch-point'
  | 'sketch-multipoint'
  | 'sketch-polyline'
  | 'sketch-polygon'
  | 'sketch-circle'
  | 'sketch-rectangle'
  | 'sketch-text';

export class SketchInputResult {
  readonly type: SketchInputType;
  readonly geometry: Geometry;

  readonly textSymbol?: TextSymbol;
  readonly text?: string;
  readonly fontSize?: number;

  constructor(
    type: SketchInputType,
    geometry: Geometry,
    textSymbol?: TextSymbol,
    textSketchInputProps?: TextSketchInputProperties
  ) {
    this.type = type;
    this.geometry = geometry;

    if (textSymbol) {
      this.textSymbol = textSymbol.clone();
    }
    if (textSketchInputProps) {
      this.text = textSketchInputProps.text;
      this.fontSize = textSketchInputProps.size;
    }
  }

  generateGraphic(): Graphic {
    const graphic = new Graphic();
    graphic.geometry = this.geometry;

    switch (this.type) {
      case 'sketch-point':
        graphic.symbol = new SimpleMarkerSymbol();
        break;
      case 'sketch-multipoint':
        graphic.symbol = new SimpleMarkerSymbol();
        break;
      case 'sketch-polyline':
        graphic.symbol = new SimpleLineSymbol();
        break;
      case 'sketch-polygon':
        graphic.symbol = new SimpleFillSymbol();
        break;
      case 'sketch-circle':
        graphic.symbol = new SimpleFillSymbol();
        break;
      case 'sketch-rectangle':
        graphic.symbol = new SimpleFillSymbol();
        break;
      case 'sketch-text':
        const textSymbol = this.textSymbol ? this.textSymbol : new TextSymbol();
        textSymbol.text = this.text!;
        textSymbol.font.size = this.fontSize!;
        graphic.symbol = textSymbol;
        break;
      default:
        throw new Error('unexpected input: type');
    }

    return graphic;
  }
}
